/**
 * Convert other units of currency to dollars.
 */
export const dollars = {
  fromCents: (amount: number) => amount / 100,
} as const;
